"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "masserano": {
    "4bca525e": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "skipSearch": false
    }],
    "baldo": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eeff1cc9": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "skipSearch": false
    }],
    "baltera": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f93b5d74": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "skipSearch": false
    }],
    "costa-forzani": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9bd7a439": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "skipSearch": false
    }],
    "dallacqua": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "106ae2ff": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "skipSearch": false
    }],
    "dallimonti": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d2bbae47": [{
      "hkey": "7a9c3a32",
      "slug": "gatti-viasco",
      "name": "Gatti Viasco",
      "primary": true,
      "skipSearch": false
    }],
    "gatti": [{
      "hkey": "7a9c3a32",
      "slug": "gatti-viasco",
      "name": "Gatti Viasco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7ada6c00": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "skipSearch": false
    }],
    "mercandetti": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5267bdee": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "skipSearch": false
    }],
    "mombello": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "60f22d0a": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "skipSearch": false
    }],
    "mongrandi": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "40de23f9": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "skipSearch": false
    }],
    "morezzi": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a0e185df": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "skipSearch": false
    }],
    "santa-liberata": [{
      "hkey": "c7231530",
      "slug": "masserano",
      "name": "Masserano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;